import React from "react";
import { Container, Row } from "react-bootstrap";
import { infoItems } from "../Data";
import "../Style/Works.scss";
import Work from "./Work";

const Works = () => {
  return (
    <div className="works_wrapper">
      <h4>WHY US</h4>
      <Container>
        <Row>
          {infoItems.map((item) => (
            <Work item={item} key={item.id} />
          ))}
        </Row>
        </Container>
    </div>
  );
};

export default Works;
